/**
 * Label of a link to a legal document in a specific locale.
 *
 * The legal bundle is passed in rather than read off the brand: it is
 * web-only (its documents are JSX), and the brand must stay plain data so the
 * API can import it without loading React.
 *
 * For a locale the brand does not have, its default locale is used: an empty
 * link in running text is worse than a link in another language.
 */
export function legalLinkLabel(brand, legal, slot, locale) {
    const labels = legal.documentLinks[slot];
    return labels[locale] ?? labels[brand.defaultLocale] ?? '';
}
//# sourceMappingURL=legal-link.js.map